import { memo } from 'react';

import { Message, type SharedMessageProps } from './message';
import { useTimeAgo } from '../../hooks';
import { Markdown } from '../../ui';

export interface UserMessageProps extends SharedMessageProps {}

export const UserMessage = memo(
  ({ group, position = 'right', variant = 'primary' }: UserMessageProps) => {
    const { messages, createdAt } = group;
    const timeAgo = useTimeAgo(createdAt);

    return (
      <Message.Root variant={variant} position={position}>
        <Message.Wrapper>
          <Message.Content>
            <Message.BubbleGroup>
              {messages.map(message => (
                <Message.Bubble key={message.id}>
                  <Markdown>{message.content ?? ''}</Markdown>
                </Message.Bubble>
              ))}
            </Message.BubbleGroup>
          </Message.Content>
        </Message.Wrapper>
        <Message.Footer>{timeAgo}</Message.Footer>
      </Message.Root>
    );
  },
);
